exports.LOGIN = 'ADMIN_LOGIN';
exports.LOGOUT = 'ADMIN_LOGOUT';
exports.LOG_WARN = 'ADMIN_LOG_WARN';
exports.LOG_ERROR = 'ADMIN_LOG_ERROR';
exports.LOG_CRITICAL = 'ADMIN_LOG_CRITICAL';



// WEBPACK FOOTER //
// ../shared/analytics_types/src/admin.js